/**
 * Script for managing the display and input of a gift message.
 * It initializes the gift message input and its toggle, sets up an event listener
 * to show or hide the gift message based on the toggle's state, and prevents emojis
 * from being entered into the gift message text area.
 */

const initGiftMessageToggle = () => {
  const giftMessage = document.getElementById('gift-message');
  const giftMessageToggle = document.getElementById('gift-message-toggle');

  if (!giftMessage || !giftMessageToggle) return;

  // Reset the gift message value
  giftMessage.value = '';

  // Listen for changes on the toggle to show/hide the gift message
  giftMessageToggle.addEventListener('change', () => {
    toggleMessage(giftMessageToggle.checked);
  });

  // Listen for input on the gift message textarea and remove emojis
  giftMessage.addEventListener('input', () => {
    const textValue = giftMessage.value;
    if (hasEmojis(textValue)) {
      giftMessage.value = textValue.replace(emojiRegex, '').trim();
    }
  });
};

// Regular expression for matching emojis
const emojiRegex =
  /(?![\d])[\p{Emoji}\p{Emoji_Modifier}\p{Emoji_Component}\p{Emoji_Modifier_Base}\p{Emoji_Presentation}]/gu;

/**
 * Toggles the display of the gift message textarea based on a checkbox.
 * @param {boolean} checked - The state of the checkbox.
 */
const toggleMessage = checked => {
  const giftMessage = document.getElementById('gift-message');
  if (giftMessage) {
    giftMessage.style.display = checked ? 'block' : 'none';
  }
  if (checked) {
    giftMessage.focus();
  }
};

/**
 * Checks if a string contains any emojis.
 * @param {string} text - The text to check for emojis.
 * @returns {boolean} True if the text contains emojis, false otherwise.
 */
const hasEmojis = text => {
  return emojiRegex.test(text);
};

/**
 * Fetches the current cart data from the server.
 * @async
 * @returns {Promise<Object>} A promise that resolves with the cart data as a JSON object.
 * @throws {Error} Throws an error if the fetch operation fails.
 */
const fetchCartData = async () => {
  const response = await fetch('/cart.js');
  if (!response.ok) throw new Error('Failed to fetch cart data');
  return response.json();
};
export { initGiftMessageToggle, fetchCartData };
